import type {PublicMethodUtils} from '@wix/document-services-types'
import type {RuntimeBindingsPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

const runtimeBindingsPublicAPI = (
    publicMethodUtils: PublicMethodUtils
): PublicModuleDeclaration<RuntimeBindingsPublicAPI> => {
    const {getter, dataManipulation} = publicMethodUtils.extensionPublicAPI

    return {
        methods: {
            components: {
                runtimeBindings: {
                    bind: dataManipulation('runtimeBindings.bind'),
                    getBoundExtensions: getter('runtimeBindings.getBoundExtensions'),
                    unbindExtensionModes: dataManipulation('runtimeBindings.unbindExtensionModes'),
                    unbind: dataManipulation('runtimeBindings.unbind'),
                    contexts: {
                        listBoundObjects: getter('runtimeBindings.contexts.listBoundObjects')
                    },
                    functions: {
                        bind: dataManipulation('runtimeBindings.functions.bind'),
                        listBoundObjects: getter('runtimeBindings.functions.listBoundObjects')
                    },
                    templates: {
                        bind: dataManipulation('runtimeBindings.templates.bind')
                    }
                },
                innerElements: {
                    runtimeBindings: {
                        bind: dataManipulation('runtimeBindings.innerElements.bind'),
                        getBoundExtensions: getter('runtimeBindings.innerElements.getBoundExtensions'),
                        unbindExtensionModes: dataManipulation('runtimeBindings.innerElements.unbindExtensionModes'),
                        unbind: dataManipulation('runtimeBindings.innerElements.unbind'),
                        functions: {
                            bind: dataManipulation('runtimeBindings.innerElements.functions.bind')
                        },
                        templates: {
                            bind: dataManipulation('runtimeBindings.innerElements.templates.bind')
                        }
                    }
                }
            }
        }
    }
}

export {runtimeBindingsPublicAPI}
